<template>
  <div class="computed-value-container">
    <index-value-details :indexValueDetails="indexValueDetails" />
    <div class="mt-8">
      <a-button
        type="primary"
        class="text-right"
        @click="onPublishButtonClicked"
        >Publish</a-button
      >
    </div>
  </div>
</template>

<script>
import IndexValueDetails from "./IndexValueDetails.vue";

export default {
  components: { IndexValueDetails },
  props: {
    indexValueDetails: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onPublishButtonClicked() {
      this.$emit("publishValue", {
        year: this.indexValueDetails.year,
        month: this.indexValueDetails.month,
      });
    },
  },
};
</script>

<style scoped>
.computed-value-container {
  display: grid;
  grid-template-rows: minmax(0, 1fr) 80px;
  height: 100%;
}
</style>
